import React, { useEffect, useState } from "react";
import { Form, Button, Collapse } from 'react-bootstrap';
import { useFormik } from "formik";
import { loadCaptchaEnginge, LoadCanvasTemplate, validateCaptcha } from 'react-simple-captcha';
import { useTranslation } from 'react-i18next';

const validateDayVisitorForm = (empData) => {
    const errors = {};

    if (!empData.VisitorName) {
        errors.VisitorName = "Please Enter Visitor's Name";
    }

    if (!empData.NRIC) {
        errors.NRIC = "Please Enter NRIC";
    }

    if (!empData.PatientFullName) {
        errors.PatientFullName = "Please Enter Patient's Full Name";
    }

    if (!empData.PatientNRIC) {
        errors.PatientNRIC = "Please Enter Patient's NRIC";
    }

    if (!empData.PatientAppDate) {
        errors.PatientAppDate = "Please Enter Patient's Application Date";
    }

    if (!empData.BotCaptcha) {
        errors.BotCaptcha = "Please Enter Captcha code";
    }

    let user_captcha_value = document.getElementById('BotCaptcha').value;
    if (validateCaptcha(user_captcha_value, false) === false) {
        errors.BotCaptcha = "Captcha Does Not Match";
    }

    return errors;
}

const DayVisitorForm = () => {
    const { t } = useTranslation(); // LANGUAGE
    const [toggleActive, setBot] = useState(false);

    const handleBotChange = (e) => {
        setBot(e.target.checked);
        // console.log("I'm not a BOT : " + e.target.checked);
    }

    useEffect(() => {
        loadCaptchaEnginge(4);
    }, []); // EMPTY ARRAY 
    const formik = useFormik({
        initialValues: {
            VisitorName: "",
            NRIC: "",
            PatientFullName: "",
            PatientNRIC: "",
            PatientAppDate: "",
            BotCaptcha: "",
        },
        validate: validateDayVisitorForm,
        onSubmit: (values) => {
            console.log(JSON.stringify(values));

            //2nd validation
            let user_captcha_value = document.getElementById('BotCaptcha').value;
            if (validateCaptcha(user_captcha_value, false) === true) {
                window.location.href = "/Successful";
            }
            else {
                console.log("....")
            }
        },
    });
    return (
        <Form onSubmit={formik.handleSubmit}>
            <Form.Row>
                <Form.Group className="col-sm-6" controlId="formGridVistorName">
                    <Form.Label>Visitor's name:</Form.Label>
                    <Form.Control
                        id="VisitorName"
                        name="VisitorName"
                        type="text"
                        onChange={formik.handleChange}
                        value={formik.values.VisitorName}
                        placeholder=""
                    />
                    {formik.touched.VisitorName && formik.errors.VisitorName ? (
                        <span style={{ color: "red" }}>{formik.errors.VisitorName}</span>
                    ) : null}
                </Form.Group>

                <Form.Group className="col-sm-6" controlId="formGridNricFin">
                    <Form.Label>Visitor’s NRIC / FIN No.:</Form.Label>
                    <Form.Control
                        id="NRIC"
                        name="NRIC"
                        type="text"
                        onChange={formik.handleChange}
                        value={formik.values.NRIC}
                        placeholder="(e.g S1234567D)"
                    />
                    {formik.touched.NRIC && formik.errors.NRIC ? (
                        <span style={{ color: "red" }}>{formik.errors.NRIC}</span>
                    ) : null}
                </Form.Group>
            </Form.Row>
            <Form.Row>
                <Form.Group className="col-sm-6" controlId="formGridPatientFName">
                    <Form.Label>Patient's Full Name:</Form.Label>
                    <Form.Control
                        id="PatientFullName"
                        name="PatientFullName"
                        type="text"
                        onChange={formik.handleChange}
                        value={formik.values.PatientFullName}
                        placeholder="(As identity card)"
                    />
                    {formik.touched.PatientFullName && formik.errors.PatientFullName ? (
                        <span style={{ color: "red" }}>{formik.errors.PatientFullName}</span>
                    ) : null}
                </Form.Group>
                <Form.Group className="col-sm-6" controlId="formGridNricFin">
                    <Form.Label>Patient's NRIC / FIN No.:</Form.Label>
                    <Form.Control
                        id="PatientNRIC"
                        name="PatientNRIC"
                        type="text"
                        onChange={formik.handleChange}
                        value={formik.values.PatientNRIC}
                        placeholder="(e.g S1234567D)"
                    />
                    {formik.touched.PatientNRIC && formik.errors.PatientNRIC ? (
                        <span style={{ color: "red" }}>{formik.errors.PatientNRIC}</span>
                    ) : null}
                </Form.Group>
            </Form.Row>
            <Form.Row>
                <Form.Group className="col-sm-6" controlId="formGridPatientWNo">
                    <Form.Label>Patient’s Appointment Date:</Form.Label>
                    <Form.Control
                        id="PatientAppDate"
                        name=""
                        type="date"
                        onChange={formik.handleChange}
                        value={formik.values.PatientAppDate}
                        placeholder=""
                    />
                    {formik.touched.PatientAppDate && formik.errors.PatientAppDate ? (
                        <span style={{ color: "red" }}>{formik.errors.PatientAppDate}</span>
                    ) : null}
                </Form.Group>
            </Form.Row>

            <Form.Row>
                <Form.Group className="col-sm-3">
                    <Form.Label>
                        {/* I'm Not a Robot: */}
                        {t('short-word.14')}
                    </Form.Label>
                    <Form.Control
                        id="ImNotaBot"
                        name="ImNotaBot"
                        type="checkbox"
                        onChange={handleBotChange}
                        checked={toggleActive}
                    />
                </Form.Group>
            </Form.Row>
 
            <br />
            <Collapse in={toggleActive}>
                <Form.Row>
                    <Form.Group className="col-sm-6" controlId="fromCaptcha">
                        <LoadCanvasTemplate />
                        <Form.Label>I'm Not a Robot:</Form.Label>
                        <Form.Control
                            id="BotCaptcha"
                            name="BotCaptcha"
                            type="text"
                            onChange={formik.handleChange}
                            value={formik.values.BotCaptcha}
                            placeholder="Enter Captcha Code" />
                        {formik.touched.BotCaptcha && formik.errors.BotCaptcha ? (
                            <span style={{ color: "red" }}>{formik.errors.BotCaptcha}</span>
                        ) : null}
                    </Form.Group>
                </Form.Row>
            </Collapse>

            <Form.Row>
                <div
                    className="btn-toolbar"
                    role="toolbar"
                    aria-label="Toolbar with button groups"
                >
                    <div
                        className="btn-group mr-3"
                        role="group"
                        aria-label="First group"
                    >
                        <Button
                            className="btn btn-primary btn-block"
                            type="submit"
                        //ref="/Successful"
                        >
                            Submit
              </Button>
                    </div>
                    <div
                        className="btn-group mr-3"
                        role="group"
                        aria-label="Second group"
                    >
                        <Button
                            className="btn btn-danger btn-block"
                            type="cancel"
                            href="/Unsuccessful"
                        >
                            Cancel
              </Button>
                    </div>
                </div>
            </Form.Row>


        </Form>
    );
};

export default DayVisitorForm;
